var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOffice(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    enableBackground: "new 0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Office_ENVIROTAINER",
    transform: "matrix(1.25,0,0,1.25,-140,-120)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M505.6,216.9H395.3v-90.7c0-4.1-3.3-7.4-7.5-7.4H135.3c-4.1,0-7.4,3.3-7.4,7.4v358.1c0,4.1,3.3,7.5,7.4,7.5 h241.6c0,0,0,0,0,0h128.7c4.1,0,7.4-3.3,7.4-7.5v-260C513.1,220.3,509.7,216.9,505.6,216.9z M239.6,383.2h-62v-42.5h62V383.2z  M239.6,300h-62v-42.5h62V300z M239.6,222h-62v-42.5h62V222z M350.3,383.2h-62v-42.5h62V383.2z M350.3,300h-62v-42.5h62V300z  M350.3,222h-62v-42.5h62V222z M482,424.4H450v-48.3H482V424.4z M482,324H450v-48.3H482V324z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOffice);
export default __webpack_public_path__ + "static/media/office.ac4c30436dd773bb3b6a17f363a902a2.svg";
export { ForwardRef as ReactComponent };